// extracted by mini-css-extract-plugin
module.exports = {"div":"Xcx_div__1EEuw","left":"Xcx_left__38MAv"};